function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _excluded = ["showValues", "isRadioButton", "isSwatch", "label", "selected", "isGrid", "seo_slug", "is_wedding_dresses"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import _extends from "@babel/runtime-corejs3/helpers/esm/extends";
import _includesInstanceProperty from "@babel/runtime-corejs3/core-js/instance/includes";
import React from "react";
import { Checkbox, RadioButton } from "@xo-union/tk-component-switches";
import SilhouetteSwitch from "../SilhouetteSwitch/index.js";
import ColorSwitch from "../ColorSwitch/index.js";
import UnionRadioStyles from "@xo-union/tk-component-switches/lib/components/RadioButton/styles.css";
import UnionCheckboxStyles from "@xo-union/tk-component-switches/lib/components/Checkbox/styles.css";
import MergeUnionCss from "../../utils/merge_union_css.js";
import Styles from "../FacetsGroup/styles.css";
var FilterItem = function FilterItem(props) {
  var blockClick = function blockClick(e) {
    e.preventDefault();
    props.onChange({
      currentTarget: {
        value: props.value
      }
    });
  };
  var getAttributes = function getAttributes() {
    var showValues = props.showValues,
      isRadioButton = props.isRadioButton,
      isSwatch = props.isSwatch,
      label = props.label,
      selected = props.selected,
      isGrid = props.isGrid,
      seo_slug = props.seo_slug,
      is_wedding_dresses = props.is_wedding_dresses,
      rest = _objectWithoutProperties(props, _excluded);
    var attributes = _objectSpread({}, rest);
    var UnionStyles = isRadioButton ? UnionRadioStyles : UnionCheckboxStyles;
    var role = isRadioButton ? "radio" : "checkbox";
    var isSelected = selected instanceof Array ? _includesInstanceProperty(selected).call(selected, seo_slug) : selected === seo_slug;
    if (!isSwatch) {
      var localStyleInfo = {
          'container': ['container'],
          'is-selected': ['is-selected'],
          'icon': ['icon'],
          'label-text': ['label-text']
        },
        labelEl = label;
      attributes['classes'] = MergeUnionCss(UnionStyles, Styles, localStyleInfo);
      attributes['aria-label'] = label;
      if (attributes.path) {
        var aProps = {
          href: attributes.path,
          onClick: blockClick,
          role: role,
          'aria-checked': isSelected,
          tabIndex: !showValues || !isGrid ? -1 : undefined
        };
        labelEl = /*#__PURE__*/React.createElement("a", aProps, labelEl);
      }
      if (isGrid) {
        attributes.is_wedding_dresses = is_wedding_dresses;
      } else {
        attributes.ref = function (ref) {
          if (ref) {
            ref.tabIndex = showValues ? 0 : -1;
          }
        };
      }
      attributes.children = labelEl;
    }
    attributes.checked = isSelected;
    attributes.isRadioButton = isRadioButton;
    return attributes;
  };
  var showValues = props.showValues,
    isRadioButton = props.isRadioButton,
    isGrid = props.isGrid,
    isSwatch = props.isSwatch;
  if (isSwatch) {
    return /*#__PURE__*/React.createElement(ColorSwitch, _extends({}, getAttributes(), {
      tabIndex: !showValues ? -1 : undefined
    }));
  } else if (isGrid) {
    return /*#__PURE__*/React.createElement(SilhouetteSwitch, getAttributes());
  } else if (isRadioButton) {
    return /*#__PURE__*/React.createElement(RadioButton, getAttributes());
  } else {
    return /*#__PURE__*/React.createElement(Checkbox, getAttributes());
  }
};
export default FilterItem;